
import { defineComponent } from "vue";
import { PermissionAction } from "@/utils/actions/PermissionAction";

export default defineComponent({
  data() {
    return {};
  },

  props: {
    action: {
      type: Object as () => PermissionAction,
      required: true
    }
  }
});
